// Remember to keep in sync with backend ABCPercentile definition
export const ABCPercentile = {
  A: 0.7,
  B: 0.2,
  C: 0.1,
} as const

export type ABCPercentileLabel = keyof typeof ABCPercentile

export const convertPercentileToPercentLabel = (percentile: ABCPercentileLabel): string => {
  return (ABCPercentile[percentile] * 100).toFixed(0) + "%"
}
